import {createAction} from "redux-actions";

//Filter Actions
export const toggleSearchFiltersAction = createAction('TOGGLE_SEARCH_FILTERS');
export const setSearchFilterTypeAction = createAction('SET_SEARCH_FILTER_TYPE');
export const setSearchSecondaryFilterAction = createAction('SET_SEARCH_SECONDARY_FILTER');
export const addSearchSecondaryFilterAction = createAction('ADD_SEARCH_SECONDARY_FILTER');
export const removeSearchSecondaryFilterAction = createAction('REMOVE_SEARCH_SECONDARY_FILTER');
export const clearSearchSecondaryFilterAction = createAction('CLEAR_SEARCH_SECONDARY_FILTER');
export const clearSearchFiltersAction = createAction('CLEAR_SEARCH_FILTERS');

//Query Actions
export const setSearchQueryAction = createAction('SET_SEARCH_QUERY');
export const setSearchLocationAction = createAction('SET_SEARCH_LOCATION');
export const setSearchGeoLocationAction = createAction('SET_SEARCH_GEO_LOCATION');
export const setSearchView = createAction('SET_SEARCH_VIEW');
export const setSearchNoResultsFound = createAction('SET_SEARCH_NO_RESULTS_FOUND');

//Trending Actions
export const incrementSearchTrendingCategoriesCount = createAction('INCREMENT_SEARCH_TRENDING_CATEGORIES_COUNT');
export const resetSearchTrendingCategoriesCount = createAction('CLEAR_SEARCH_TRENDING_CATEGORIES_COUNT');

//Result Actions
export const requestSearchItemsAction = createAction('REQUEST_SEARCH_ITEMS');
export const receiveSearchItemsAction = createAction('RECEIVE_SEARCH_ITEMS');
export const clearSearchItemsAction = createAction('CLEAR_SEARCH_ITEMS');
export const requestSearchGeoLocationAction = createAction('REQUEST_SEARCH_GEO_LOCATION_ACTION');



// WEBPACK FOOTER //
// ./app/client/search/actions.ts